export var BitrateCapReason = /*#__PURE__*/ function(BitrateCapReason) {
    BitrateCapReason["CoordinatedBitrateCap"] = "Coordinated Bitrate Cap";
    BitrateCapReason["DeviceCapabilityCap"] = "Device Capability Cap";
    BitrateCapReason["MobileNetworkThrottle"] = "Mobile Network Throttle";
    BitrateCapReason["UserConfiguredCap"] = "User Configured Cap";
    BitrateCapReason["SecurityEnforcedCap"] = "Security Enforced Cap";
    return BitrateCapReason;
}({});

//# sourceMappingURL=meta-list-manager.enums.js.map